module.exports = __webpack_public_path__ + "img/Huawei.81da5cea.jpg";